4<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="lg"
    :no-enforce-focus="false"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-card-body>
          <form autocomplete="off">
            <div class="row">
              <div class="col-sm-12">
                <div class="container-fluid custom-scroll">
                  <div class="row row-item" v-if="!participant">
                    <div class="col texts-box text-truncate">
                      <div class="text-2 text-truncate text-center text-muted">Nenhuma participante informado</div>
                    </div>
                  </div>
                  <div class="row row-item">
                    <div class="col texts-box text-truncate">
                      <div class="text-1 text-truncate">{{ participant.name }} <i style="font-size: 18px;" :class="participant.gender === 'Feminino' ? 'bx bx-female-sign text-pink' : 'bx bx-male-sign text-primary'"></i></div>
                      <div class="text-2 text-truncate">{{ participant.email }}</div>
                    </div>
                    <div class="col-auto">
                      <div class="flex justify-end">
                        <span class="badge badge-soft-primary font-size-12" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden;">
                          {{ participant.group ? participant.group.data.name : 'SEM GRUPO' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="hotel_id">Hotel *</label>
                  <select
                    id="hotel_id"
                    v-model="allocation.hotel_id"
                    name="hotel_id"
                    class="form-control"
                    @change="setHotel(allocation.hotel_id)"
                    :class="{
                      'is-invalid': submitted && $v.allocation.hotel_id.$error
                    }"
                  >
                    <option value="null" disabled>Selecione um Hotel</option>
                    <option v-for="item in hotels" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                  <div
                    v-if="submitted && !$v.allocation.hotel_id.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
                <div class="mb-4" v-if="hotelSelected.id">
                  <div class="d-flex align-items-center gap-1 items-center mb-2">
                    <i class="bx bxs-info-circle text-primary font-size-16"></i>
                    <span class="text-muted">Capacidade: {{ hotelSelected.allocatedRooms }}/{{ hotelSelected.capacity }} ocupados</span>
                  </div>
                  <b-progress :max="hotelSelected.capacity" height="4px" variant="primary" size="sm">
                    <b-progress-bar :value="hotelSelected.allocatedRooms">
                    </b-progress-bar>
                  </b-progress>
                </div>
              </div>
            </div>
            <div class="row" v-if="hotelSelected.id">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="hotel_date_range_id">Range de datas *</label>
                  <select
                    id="hotel_date_range_id"
                    v-model="allocation.hotel_date_range_id"
                    name="hotel_date_range_id"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.allocation.hotel_date_range_id.$error
                    }"
                  >
                    <option :value="null" disabled>Selecione o período</option>
                    <option v-for="range in dateRanges" :key="range.id" :value="range.id">
                      {{ $moment(range.check_in).format('DD/MM/YYYY') }} até {{ $moment(range.check_out).format('DD/MM/YYYY') }}
                    </option>
                  </select>
                  <div
                    v-if="submitted && !$v.allocation.hotel_date_range_id.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Categoria *</label>
                  <select
                    id="name"
                    v-model="allocation.category_id"
                    name="name"
                    placeholder="Ex: Basic, Deluxe, etc"
                    @change="getTypesAccommodations()"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.allocation.category_id.$error
                    }"
                  >
                    <option value="null" disabled>Selecione uma categoria</option>
                    <option v-for="item in categories" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                  <div
                    v-if="submitted && !$v.allocation.category_id.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Tipo de Acomodação *</label>
                  <select
                    id="name"
                    v-model="allocation.type_room"
                    name="name"
                    class="form-control"
                    @change="listRooms()"
                    :class="{
                      'is-invalid': submitted && $v.allocation.type_room.$error
                    }"
                  >
                    <option value="null" disabled>Selecione um tipo de acomodação</option>
                    <option v-for="(item,idx) in typeAccomodations" :key="idx" :value="item.type_room">{{ item.desc_room }}</option>
                  </select>
                  <div
                    v-if="submitted && !$v.allocation.type_room.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="description">Quartos Disponíveis</label>
                  <div
                    v-if="submitted && !$v.allocation.type_room.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                  <div class="row-item" v-if="!allocation.type_room || !allocation.category_id || !allocation.hotel_id">
                    <div class="col texts-box text-truncate">
                      <div class="text-2 text-truncate text-center text-muted">Nenhum quarto disponível. Selecione Hotel e Categoria</div>
                    </div>
                  </div>
                  <div class="item-row d-flex justify-content-start mt-2">
                    <div class="col-item-2 d-flex" v-for="(room, i) in rooms" :key="i">
                      <div class="item-mb-3 w-100 position-relative">
                        <label class="card-radio-label">
                          <input
                            type="radio"
                            class="card-radio-input"
                            :value="room.id"
                            name="room_id"
                            :disabled="room.status === 0"
                            :id="room.id"
                            v-model="allocation.room_id"
                            @change="setRoom(room.id)"
                          />
                          <div class="card-radio position-relative" :class="{ 'room-b-partial': room.status === 1 && (room.allocations > 0 && room.allocations < room.capacity), 'room-b-occuped': room.status === 0 }">
                            <div class="d-flex flex-column align-items-center">
                              <span>{{ room.id }}</span>
                            </div>
                            <!-- Green checkmark for available rooms (e.g., DPL01) -->
                            <i
                              v-if="room.status === 1 && room.allocations === 0"
                              class="bx bxs-check-circle font-size-18 position-absolute top-0 end-0 text-success"
                            ></i>
                            <!-- Orange indicator for selected rooms (e.g., 102, 202) -->
                            <!-- <i
                              class="bx bx-circle position-absolute top-0 end-0 text-warning"
                            ></i> -->
                            <span v-if="room.status === 1 && (room.allocations > 0 && room.allocations < room.capacity)"  class="room-partial position-absolute top-0 end-0">1</span>
                            <span v-if="room.status === 0" class="room-occuped position-absolute top-0 end-0">2</span>
                          </div>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-1 items-center mb-4">
                  <div>
                    <i class="bx bxs-circle text-success"></i> <span class="text-muted">Disponível</span>
                  </div>
                  <div>
                    <i class="bx bxs-circle text-warning"></i> <span class="text-muted">Parcialmente ocupado</span>
                  </div>
                  <div>
                    <i class="bx bxs-circle text-danger"></i> <span class="text-muted">Lotado</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2" v-if="roomSelected.id">
              <div class="col-sm-12">
                <div class="d-flex wrap justify-content-between">
                  <span class="font-size-15" >Quarto Selecionado: <b>{{ roomSelected.id }}</b></span>
                  <div class="d-flex align-items-center gap-1 items-center mb-2">
                    <i class="bx bxs-info-circle text-success font-size-16"></i>
                    <span class="text-success">Esse quarto ainda tem {{ (roomSelected.capacity - roomSelected.allocations) }} vaga disponível</span>
                  </div>
                </div>
                  <div class="row-item p-3">
                    <div class="d-flex wrap justify-content-between">
                      <span class="" >Ocupantes atuais: </span>
                      <div class="d-flex align-items-center gap-1 items-center mb-2">
                        <span class="text-success">{{ roomSelected.allocations }}/{{ roomSelected.capacity }} pessoas</span>
                      </div>
                    </div>
                    <div class="row row-item m-2 mt-3" v-if="roomSelected.allocation.length === 0">
                      <div class="col texts-box text-truncate">
                        <div class="text-2 text-truncate text-center text-muted">Nenhum participante alocado nesse quarto</div>
                      </div>
                    </div>
                    <div class="row row-item m-2 mt-3" v-for="(a, i) in roomSelected.allocation" :key="i">
                      <div class="col texts-box text-truncate">
                        <div class="text-1 text-truncate">{{ a.participant.data.name }} <i style="font-size: 18px;" :class="a.participant.data.gender === 'Feminino' ? 'bx bx-female-sign text-pink' : 'bx bx-male-sign text-primary'"></i></div>
                        <div class="text-2 text-truncate">{{ a.participant.data.email }}</div>
                      </div>
                      <div class="col-auto">
                        <div class="flex justify-end">
                          <span class="badge badge-soft-primary font-size-12" style="font-weight: 400; white-space: nowrap;text-overflow: ellipsis;max-width: 260px;overflow: hidden;">
                            {{ a.participant.data.group ? a.participant.data.group.data.name : 'SEM GRUPO' }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="obs">Observações</label>
                  <textarea
                    id="obs"
                    v-model="allocation.obs"
                    name="obs"
                    placeholder="Informações adicionais sobre a alocação..."
                    class="form-control"
                    rows="3"
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </form>
        </b-card-body>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" :disabled="user.role !== 'Admin'" @click="saveAllocation()">Confirmar Alocação</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { EventBus } from '@/eventBus'

export default {
  components: {
    Loading
  },
  props: {},
  data () {
    return {
      title: 'Alocar Participante',
      loading: true,
      participant: {},
      hotelSelected: {},
      roomSelected: {
        id: null,
        capacity: 0,
        allocations: 0,
        allocation: []
      },
      typeAccomodations: [],
      rooms: [],
      categories: [],
      fullPage: true,
      submitted: false,
      beds: [
        {
          value: 'single',
          label: 'Single',
          capacity: 1,
          svg: 1
        },
        {
          value: 'duplo-casal',
          label: 'Duplo Cama Casal',
          capacity: 2,
          svg: 1
        },
        {
          value: 'double-twin',
          label: 'Duplo Twin',
          capacity: 2,
          svg: 2
        },
        {
          value: 'triple-twin',
          label: 'Triplo Twin',
          capacity: 3,
          svg: 3
        },
        {
          value: 'quadruple-twin',
          label: 'Quádruplo Twin',
          capacity: 4,
          svg: 4
        }
      ],
      allocation: {
        hotel_id: null,
        hotel_date_range_id: null,
        match_room_id: null,
        participant_id: null,
        type_room: null,
        qty: null
      },
      dateRanges: [],
      modal: false,
      modalForm: false
    }
  },
  validations: {
    allocation: {
      hotel_id: { required },
      hotel_date_range_id: { required },
      category_id: { required },
      type_room: { required },
      room_id: { required }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('room', {
      getRooms: 'getListRooms'
    }),
    ...mapActions('hotel', {
      getHotels: 'getAll'
    }),
    ...mapActions('hotelAccommodation', {
      typesAccommodations: 'getTypeAccomodations'
    }),
    ...mapActions('hotelAllocation', {
      getAllocation: 'getAllocation',
      postData: 'save'
    }),
    ...mapActions('hotelCategory', {
      getAll: 'getAll'
    }),
    setRoom (roomId) {
      let roomSelected = this.rooms.find(r => r.id === roomId)
      if (roomSelected) {
        this.roomSelected = { ...roomSelected }
        this.roomSelected.allocation = roomSelected.allocation?.data ?? []
      } else {
        this.roomSelected = null
      }
    },
    listRooms () {
      let params = {
        hotel_id: this.hotelSelected.id || null,
        category_id: this.allocation.category_id || null,
        type_room: this.allocation.type_room || null,
        limit: 50,
        include: 'allocation.participant'
      }
      this.getRooms(params).then((res) => {
        this.rooms = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    getTypesAccommodations () {
      let params = {
        hotel_id: this.hotelSelected.id || null,
        category_id: this.allocation.category_id || null
      }
      this.typesAccommodations(params).then((res) => {
        this.typeAccomodations = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    setHotel (hotelId) {
      this.hotelSelected = this.hotels.filter(h => h.id === hotelId)[0]
      this.dateRanges = (this.hotelSelected && this.hotelSelected.date_ranges) ? this.hotelSelected.date_ranges : []
      this.allocation.hotel_date_range_id = null
      if (this.hotelSelected) {
        this.getCategories()
      }
    },
    listHotels () {
      let params = {
        search: null,
        limit: 100,
        page: 1
      }
      this.getHotels(params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    getCategories () {
      let params = {
        hotel_id: this.hotelSelected.id || null,
        search: null,
        limit: 100,
        page: 1
      }
      this.getAll(params).then((res) => {
        this.categories = res.data
      }).catch(error => {
        console.log(error)
      })
    },
    loadItem (participant) {
      if (participant) {
        this.listHotels()
        this.participant = participant
        this.loading = false
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      // this.getCategories()
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveAllocation () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      this.allocation.participant_id = this.participant.id
      await this.postData(this.allocation).then(res => {
        let message = 'Sucesso: Alocação de participante realizada com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('created')
        EventBus.$emit('allocationAdded', 1)
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.allocation = {}
      this.hotelSelected = {}
      this.roomSelected = {
        id: null,
        capacity: 0,
        allocations: 0,
        allocation: []
      }
      this.rooms = []
      this.typeAccomodations = []
      this.categories = []
      this.$v.$reset()
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('event', ['setting']),
    ...mapState('hotelAllocation', { data: 'accommodation' }),
    ...mapState('hotel', ['hotels'])
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.modal-header {
  background: #000 !important;
  color: #fff;
}
.border-gray {
  border: 1px solid #e9e9e9;
}
.item-row {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}
.col-item-2 {
  flex: 1 1 0;
  max-width: 170px;
  min-width: 170px;
  display: flex;
  justify-content: flex-start;
  height: 44px;
}
.item-mb-3 {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card-radio-label {
  display: block;
  width: 100%;
}
.room-available {
}
.card-radio {
  display: flex;
  justify-content: center;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  position: relative; /* Ensure the container is positioned for absolute children */
}
.card-radio svg {
  margin-bottom: 2px;
}
.card-radio span {
  display: block;
}
.row-item {
  --padding: 5px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 2px;
  }
  background: #F9FAFB;
  border-radius: 5px;
  /* margin-bottom: 16px; */
  padding: var(--padding);
  border: 1px solid #E5E7EB;
  align-items: center;
}
.texts-box {
  .text-1 {
    font-size: 16px;
    color: #05162B;
  }
  .text-2 {
    font-size: 12px;
    color: #05162B87;
  }
}
.room-partial {
  background: #ff9800;
  width: 14px;
  font-weight: 500;
  font-size:10px;
  border-radius: 50%;
  color: #FFFFFF;
}
.room-occuped {
  background: #EF4444;
  width: 14px;
  font-weight: 500;
  font-size:10px;
  border-radius: 50%;
  color: #FFFFFF;
}
/* Positioning for icons */
.position-absolute {
  position: absolute;
}
.top-0 {
  top: 1px;
}
.start-0 {
  left: 0;
}
.end-0 {
  right: 1px;
}
.text-success {
  color: #16A34A !important;
}
.text-warning {
  color: #ff9800; /* Orange indicator color */
}
.room-b-partial {
  border: 1px solid #FDBA74;
  background: #FFF7ED;
}
.room-b-occuped {
  border: 1px solid #FCA5A5;
  background: #FEF2F2;
}
/* .text-blue {
  color: #0D6EFD;
}
.text-pink {
  color: #F51919;
} */
</style>
